module.exports = __webpack_public_path__ + "img/Dimitris_Cyprus.deb20fec.jpeg";